import React from 'react'
import styles from './LoadExisting.scss'
import {SearchBar} from 'features/search/SearchBar'
import {SearchResults} from 'features/search/SearchResults'
import {FiltersCrumbs} from 'features/search/FiltersCrumbs'
import {connect, Provider} from 'react-redux'
import * as searchActions from 'lib/api/search'
import {loadClubs} from 'lib/api/currentUser'
import {initStore} from '../redux/initStore'
import {ModalOverlay} from 'common/styleguide/ModalOverlay'
import blueTheme from 'common/styleguide/ModalOverlay/blueHeaderModalTheme.scss'
import {CTA} from 'common/styleguide/CTA'
import {loadStatus} from 'lib/promiseMiddlewareHelpers'
import {List} from 'immutable'
import cx from 'classnames'

const store = initStore()

export const resultTypes = {
  CLUB: 2,
  USER: 1,
  PUBLIC: 3
}

class Footer extends React.Component {
  render () {
    const {numSelected, onAdd, onCancel, submitLabel, collapse} = this.props

    return (
      <div className={styles.Footer}>
        <CTA inline link margins={false} onClick={onCancel}>Cancel</CTA>
        <div className={cx(styles.selected, collapse && styles.collapse)}>
          {numSelected > 0 && `${numSelected} Selected`}
        </div>
        <CTA inline margins={false} onClick={onAdd}>{submitLabel || 'Add to Planner'}</CTA>
      </div>
    )
  }
}

class LoadExisting extends React.PureComponent {
  constructor (props) {
    super(props)

    this.state = {
      selected: List()
    }
  }

  componentDidMount = () => {
    const {loadClubs, currentUser} = this.props

    const clubsLoaded = currentUser && currentUser.clubs && !!currentUser.clubs.get('loadStatus')
    loadClubs && !clubsLoaded && loadClubs()

    this.doSearch(this.defaultQuery())
  }

  defaultQuery () {
    if (this.props.routesOnly) {
      return searchActions.defaultQuery().set('trips', false)
    } else {
      return searchActions.defaultQuery()
    }
  }

  doSearch = (query) => {
    const {search, currentUser, allowedResultTypes} = this.props

    const defaultQuery = this.defaultQuery()
    const isDefaultQuery = query.toMap().every((value, key) => defaultQuery.get(key) === value)

    if (isDefaultQuery) {
      const userSearch = defaultQuery.merge({
        'user_id': currentUser.id,
        'sort_by': 'created+desc'
      })
      search(userSearch, defaultQuery, {type: resultTypes.USER})
      return
    }

    if (!allowedResultTypes || allowedResultTypes.includes(resultTypes.USER)) {
      search(query.merge({ 'user_id': currentUser.id }), query, { type: resultTypes.USER })
    }
    if (!allowedResultTypes || allowedResultTypes.includes(resultTypes.PUBLIC)) {
      search(query, query, {type: resultTypes.PUBLIC})
    }
    if (!allowedResultTypes || allowedResultTypes.includes(resultTypes.CLUB)) {
      if (currentUser.clubs.get('loadStatus') === loadStatus.fulfilled) {
        currentUser.clubs.get('records').entrySeq().forEach(([id, c]) => {
          search(query.merge({'user_id': c.get('user_id')}), query, {type: resultTypes.CLUB})
        })
      }
    }
  }

  loadMore = () => {
    const {query, search} = this.props

    return (newQuery, meta) => {
      search(newQuery, query, meta)
    }
  }

  pickResult = (result) => {
    const {selected} = this.state

    if (selected.find((r) => r.get('type') === result.get('type') && r.get('id') === result.get('id'))) {
      this.setState({
        selected: selected.filterNot((r) => r.get('type') === result.get('type') && r.get('id') === result.get('id'))
      })
    } else {
      this.setState({
        selected: selected.push(result)
      })
    }
  }

  onAdd = () => {
    const {loadRoute, loadMultiple, onRequestClose} = this.props
    const {selected} = this.state

    loadRoute && selected.forEach((r) => {
      loadRoute(r.get('id'), r.get('type'))
    })

    loadMultiple && loadMultiple(
      selected.map(r => [r.get('id'), r.get('type')])
    )

    // TODO: should I wait until all are sucessful?
    onRequestClose()
  }

  onCancel = () => {
    this.props.onRequestClose()
  }

  render () {
    const {query, currentUser, results, onRequestClose, routesOnly, submitLabel, collapse} = this.props
    const {selected} = this.state

    const metricUnits = currentUser.preferences.get('metric_units', false)

    // Add up the counts for all the groups we're showing
    const resultsCount = results.entrySeq().reduce((sum, [q, rg]) => (sum + rg.get('results_count')), 0)

    return (
      <ModalOverlay
        title={routesOnly ? 'Import Routes' : 'Import Routes & Rides'}
        subtitle={<SearchBar doSearch={(q) => this.doSearch(q)} query={query} metricUnits={metricUnits} currentUser={currentUser} />}
        footer={<Footer collapse={collapse} onCancel={this.onCancel} onAdd={this.onAdd} numSelected={selected.size} submitLabel={submitLabel} />}
        maxWidth='800px'
        contentPadding={false}
        onRequestClose={onRequestClose}
        theme={blueTheme}>
        <div className={styles.LoadExisting}>
          <div className={styles.meta}>
            <div className={styles.results}>{resultsCount.toLocaleString()} results found.</div>
            <FiltersCrumbs
              query={query}
              doSearch={(q) => this.doSearch(q)}
              metricUnits={metricUnits} />
          </div>
          <SearchResults
            routesOnly={routesOnly}
            results={results}
            currentUser={currentUser}
            selectedResults={selected}
            clickResult={this.pickResult}
            loadMore={this.loadMore()} />
        </div>
      </ModalOverlay>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const {search, currentUser} = state
  return {
    query: search.get('key'),
    queries: search.get('queries'),
    results: search.get('results'),
    currentUser: currentUser
  }
}

const mapDispatchToProps = {
  search: searchActions.search,
  loadClubs: loadClubs
}

export const LoadExistingContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(LoadExisting)

export const LoadExistingApp = (props) => (
  <Provider store={store}>
    <LoadExistingContainer {...props} />
  </Provider>
)
